<template>
  <div class="form-group">
    <label :for="name">{{ label }}</label>
    <VeeField
      :id="name"
      :name="name"
      :label="label"
      :model-value="modelValue"
      :value="modelValue"
      class="form-input"
      v-bind="$attrs"
      @input="onInput"
      @change="onChange"
      @blur="onBlur"
    />
    <VeeErrorMessage
      :name="name"
      class="form-error"
    />
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    name: { type: String, required: true },
    label: { type: String, default: '' },
    modelValue: { type: String, default: '' }
  },
  emits: ['modelUpdate', 'update:modelValue'],
  methods: {
    updateValue (event) {
      const value = event?.target?.value ?? event
      this.$emit('modelUpdate', value)
      this.$emit('update:modelValue', value)
    },
    onInput (event) {
      this.updateValue(event)
    },
    // Some browsers and password managers only commit password values on
    // change or blur. Keep the parent model in sync for those paths too.
    onChange (event) {
      this.updateValue(event)
    },
    onBlur (event) {
      this.updateValue(event)
    }
  }
}
</script>
